import storage from '../../utils/storage'

const STORAGE_KEY = 'tr_v3_report_contents_real'

export default {
  state: {
    contents: []
  },
  mutations: {
    SET_CONTENTS(state, list) {
      state.contents = list
      storage.set(STORAGE_KEY, list)
    },
    ADD_CONTENT(state, item) {
      state.contents.push(item)
      storage.set(STORAGE_KEY, state.contents)
    },
    UPDATE_CONTENT(state, item) {
      const idx = state.contents.findIndex(c => c.content_id === item.content_id)
      if (idx >= 0) {
        state.contents.splice(idx, 1, item)
        storage.set(STORAGE_KEY, state.contents)
      }
    },
    DELETE_CONTENT(state, id) {
      state.contents = state.contents.filter(c => c.content_id !== id)
      storage.set(STORAGE_KEY, state.contents)
    }
  },
  getters: {
    allContents: state => state.contents,
    contentsByType: state => type => state.contents.filter(c => c.type === type && c.status === 1),
    contentsByRiskLevel: state => (type, riskLevel) => state.contents.filter(c =>
      c.type === type && c.status === 1 && (c.risk_level === 0 || c.risk_level === riskLevel)
    ),
    // 根据风险等级 + 行为标签 + 关键词匹配内容
    // 匹配优先级：① behavior_tags 精确命中 > ② keywords 模糊匹配 > ③ 仅风险等级匹配
    // 同优先级内按 sort_order 升序排列
    contentsByRiskAndKeywords: state => (type, riskLevel, behaviorIds = [], behaviorKeywords = []) => {
      const baseList = state.contents.filter(c =>
        c.type === type && c.status === 1 && (c.risk_level === 0 || c.risk_level === riskLevel)
      )
      // 行为标签精确匹配计数
      const behaviorMatchCount = (tags) => {
        if (!behaviorIds.length || !tags || !tags.length) return 0
        return tags.filter(tag => behaviorIds.includes(tag)).length
      }
      // 关键词模糊匹配计数
      const keywordMatchCount = (keywords) => {
        if (!behaviorKeywords.length || !keywords || !keywords.length) return 0
        return keywords.filter(k => behaviorKeywords.some(bk => bk.includes(k))).length
      }
      return baseList.sort((a, b) => {
        const aBehaviorMatch = behaviorMatchCount(a.behavior_tags)
        const bBehaviorMatch = behaviorMatchCount(b.behavior_tags)
        // ① 行为标签命中数（降序）
        if (bBehaviorMatch !== aBehaviorMatch) return bBehaviorMatch - aBehaviorMatch

        const aKeywordMatch = keywordMatchCount(a.keywords)
        const bKeywordMatch = keywordMatchCount(b.keywords)
        // ② 关键词命中数（降序）
        if (bKeywordMatch !== aKeywordMatch) return bKeywordMatch - aKeywordMatch

        // ③ 排序号（升序）
        return (a.sort_order || 999) - (b.sort_order || 999)
      })
    }
  }
}
